import React from "react";
import Navbar from "./components/navbar/Navbar";
import MyBanner from "./components/banner/MyBanner";
import MyFeatures from "./components/features/MyFeatures";
import MyProjects from "./components/projects/MyProjects";
import MyResume from "./components/resume/MyResume";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import FooterEnd from "./components/footer/FooterEnd";
function App() {
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <Navbar />
      <div className="max-w-screen-xl mx-auto">
    
      <MyBanner/>
      <MyFeatures/>
      <MyProjects/>
      <MyResume/>
      <Contact/>
      <Footer/>
      <FooterEnd/>
      </div>
     
    </div>
  );
} 

export default App;
